import { Component, Input, OnInit } from '@angular/core';
import { ElementComponent } from '../element-wyswyg/element-wyswyg.component';

@Component({
  selector: 'code-wyswyg',
  templateUrl: './code-wyswyg.component.html',
  styleUrls: ['./code-wyswyg.component.css']
})
export class CodeWyswygComponent extends ElementComponent implements OnInit {
  @Input() override data: any = {
    text: '',
	  codeLang: "javascript"
  }

	availableLanguages: string[] = [
    "cpp", // c++, cambiar para que en el selector salga un nombre y a monaco se le pase otro
    "csharp",
	  "css",
    "dart",
	  "html",
    "java",
	  "javascript",
    "json",
    "kotlin",
    "php",
    "python",
    "scss",
    "sql",
    "typescript",
    "xml",

	];
	userTheme: string = "vs-dark";
	editorOptions: any = {

	};

  ngOnInit(): void {
    this.editorOptions = {
      theme: this.userTheme,
      language: this.data.codeLang || 'javascript',
      roundedSelection: true,
      autoIndent: true,
      scrollbar: {
        alwaysConsumeMouseWheel: false
      }
    };
  }

	changeLanguage(event) {
		this.editorOptions = {...this.editorOptions, language: event.target.value}
  }

}
